export interface FondoInterface {
    imagen:string;
    alineacion:string;
    color:string;
}

export class Fondo {
    constructor(
        public imagen:string,
        public alineacion:string,
        public color:string
    ) {
    }
}

export class FondoMaker {
    static createInterface(event:FondoInterface):FondoInterface {
        return { imagen: event.imagen, alineacion: event.alineacion, color: event.color }
    }

    static create(event: Fondo) {
        return new Fondo( event.imagen, event.alineacion, event.color );
    }
}